export const environment = {
  production: true,
  occBaseUrl: null,
  captchaSiteKey: '6LdLl_QrAAAAANbi8Y0gxYbHgNo18NFXe4jPohis',

  // Datadog RUM/Logs — see environment.ts for the rationale ("eCommerce-na"
  // RUM application, dedicated to this NA/Canada+SanofiShop subscription).
  datadog: {
    applicationId: '2cd1d7d3-5eff-4b63-a0ce-b56e4f15645a',
    clientToken: 'pub395997b6e34763badf20a0ce7ee7ade9',
    site: 'datadoghq.eu',
    service: 'ssspartacusstore',
    defaultEnv: 'test',
  },
};
